// extracted by css-extract-rspack-plugin
export default {"box":"Spinner-module__box___U_Jlp","ring":"Spinner-module__ring___p00cd","spin":"Spinner-module__spin___L9LPq"};